<template>
  <v-dialog v-model="dialog" max-width="680">
    <v-card v-if="news">
      <v-card-title>{{ news.title }}</v-card-title>
      <v-card-text v-html="news.content"></v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          depressed
          color="primary"
          @click="read"
          :block="$vuetify.breakpoint.smAndDown"
        >
          {{ $t('我己閱讀並了解') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex';

export default {
  props: {
    news: Object,
  },

  data() {
    return {
      dialog: false,
    }
  },

  watch: {
    news() {
      this.dialog = !!this.news;
    }
  },

  methods: {
    read() {
      this.dialog = false;
      this.$emit('read', this.news);
    }
  },
}
</script>
